import React, { useState } from 'react'
import styled from 'styled-components'

import Popup from '../../components/Popup'

import ToGoLogo from '../../assets/images/bdtogo-logo.png'

const Wrapper = styled.div`
  width: 100%;
  margin: 0px;

  > svg {
    display: inline-flexl;
    align-items: center;
    justify-ocntent: center;
    width: 120px;
    margin: 0;
  }

  ${({ theme }) => theme.media.l} {
    margin: 0 0 80px 15px;

    > svg {
      width: 220px;
    }
  }

  ${({ theme }) => theme.media.xl} {
    > svg {
      width: 240px;
    }
  }

  ${({ theme }) => theme.media.xxl} {
    > svg {
      width: 280px;
    }
  }
`

const LogoImg = styled.div`
  display: flex;
  width: 140px;
  height: 140px;
  margin: 0;
  align-items: center;

  > img {
    width: 100%;
  }

  ${({ theme }) => theme.media.l} {
    margin: 0 0 0 15px;
    width: 220px;
    height: 220px;
  }

  ${({ theme }) => theme.media.xl} {
    width: 240px;
    height: 240px;
  }

  ${({ theme }) => theme.media.xxl} {
    width: 280px;
    height: 280px;
  }
`

const Deliveries = ({restaurant, home}) => {

    const [menuPopup, setMenuPopup] = useState(false);
    
    return (
        <Wrapper home={{home}}>
            <LogoImg>
              <img onClick={() => setMenuPopup(true)} src={ToGoLogo} alt={restaurant.Name} style={{cursor: 'pointer', width: '100%'}} />
            </LogoImg>
            <Popup
                small
                active={menuPopup === true}
                handleClose={() => setMenuPopup(false)}
            >
                <ul>
                    <li>
                        <a
                            href="https://www.foodpanda.hk/restaurant/s6ek/bombay-dreams-sheung-wan"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="menu-links"
                            >
                            foodpanda
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://deliveroo.hk/en/menu/hong-kong/sheung-wan/bombay-dreams-indian-cuisine"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="menu-links"
                            >
                            Deliveroo
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://bombaydreamstogo.oddle.me"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="menu-links"
                            >
                            ODDLE EATS
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.openrice.com/en/hongkong/r-bombay-to-go-sheung-wan-indian-r632865"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="menu-links"
                            >
                            OpenRice
                        </a>
                    </li>
                </ul>
            </Popup>
        </Wrapper>
    )
}

export default Deliveries;